import type { RateCardRow } from "../data/db.ts";

/** The five levers, in the order they are always worked (Five-Lever Audit Playbook v1.0). */
export const LEVERS = [
  { n: 1, name: "Dimensional and band audit", what: "Charged weight against actual weight, and the carrier price band each parcel falls in." },
  { n: 2, name: "Right-sizing and format switching", what: "Products moved into boxes or mailers that fit, for example a box to a mailer or into a smaller size band." },
  { n: 3, name: "Material and levy optimisation", what: "Lighter, cheaper materials, and packaging levy ratings for larger clients." },
  { n: 4, name: "Supplier and procurement", what: "Better prices and terms from packaging suppliers, once the formats are settled." },
  { n: 5, name: "Carrier strategy and negotiation", what: "The right carrier and service, then rate negotiation, once the dimensional data is reliable." },
] as const;

/** The newest version of each rate card. */
export function latestCards(rows: RateCardRow[]): RateCardRow[] {
  const byId = new Map<string, RateCardRow>();
  for (const r of rows) {
    const cur = byId.get(r.id);
    if (!cur || r.effective_from > cur.effective_from || (r.effective_from === cur.effective_from && r.version > cur.version)) byId.set(r.id, r);
  }
  return [...byId.values()].sort((a, b) => a.id.localeCompare(b.id));
}

export const cardRef = (r: { id: string; version: string }) => `${r.id}@${r.version}`;
